import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const COMPARE_LIMIT = 3;

export interface CompareItem {
  id: number;
  title: string;
  district: string | null;
  state: string | null;
  land_type: string | null;
  area: string | number | null;
  area_unit: string | null;
  asking_price: string | number | null;
  riskLevel?: string;
  lawyerVerified?: boolean;
}

interface CompareState {
  ids: number[];
  items: Record<number, CompareItem>;
}

const initialState: CompareState = { ids: [], items: {} };

export const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {
    // NOTE: a bare id is still accepted — the broker detail page adds without a snapshot.
    addToCompare: (state, action: PayloadAction<number | CompareItem>) => {
      const payload = action.payload;
      const id = typeof payload === 'number' ? payload : payload.id;
      if (!state.ids.includes(id)) {
        if (state.ids.length >= COMPARE_LIMIT) return;
        state.ids.push(id);
      }
      if (typeof payload !== 'number') state.items[id] = payload;
    },
    removeFromCompare: (state, action: PayloadAction<number>) => {
      state.ids = state.ids.filter((id) => id !== action.payload);
      delete state.items[action.payload];
    },
    clearCompare: (state) => {
      state.ids = [];
      state.items = {};
    }
  }
});

export const { addToCompare, removeFromCompare, clearCompare } = compareSlice.actions;
export const compareReducer = compareSlice.reducer;
